export default "__VITE_ASSET__b07a24fb__"